<script>
import EntitiesTable from '$common/EntitiesTable'
import courses from '@/global/js/courses'
export default {
  name: 'AdminStudents',
  components: {
    'entities-table': EntitiesTable,
  },
  data () {
    return {
      isReady: false,
      students: [],
      studentIdToGuardian: {},
      studentIdToStartDateClass: {},
      filter_course: '',
      filter_month: '',
      classes: {},
      courses,
      sorting: {
        by: 'Name',
        ascending: true,
      },
      cells: [
        {
          name: 'Name',
          getInfo: student => student.name,
          sortFunc: (a, b) => a.name.localeCompare(b.name),
          onClick: (student) => {
            this.$modals.show({
              name: 'student-details',
              student: student,
              classes: this.classes,
            })
          },
        },
        {
          name: 'Age',
          getInfo: student => student.birthday ? this.$getAge(student.birthday) : '-',
          sortFunc: (a, b) => this.$getAge(a.birthday || 0) - this.$getAge(b.birthday || 0),
        },
        {
          name: 'Paperwork',
          getInfo: student => student.paperwork_complete ? 'done' : 'highlight_off',
          sortFunc: (a, b) => a.paperwork_complete ? 1 : -1,
          classFunc: student => 'material-icons ' + (student.paperwork_complete ? 'green-font' : 'red-font'),
          onClick: (student) => {
            if (student.paperwork_complete) return this.$toast('Paperwork complete')
            this.$modals.show({
              name: 'paperwork',
              guardianId: student.guardian_id,
              onSuccess: this.getEntities,
              hardClose: true,
            })
          },
        },
        {
          name: 'Payment Status',
          getInfo: student => ({
            APPROVED: 'Approved for scholarship',
            APPROVED_NOT_PAID: 'Approved - not paid',
            FULLY_PAID: 'Paid in full',
            PENDING: 'Scholarship pending',
            OFFER_SENT: 'Different scholarship proposed',
            SCHOLARSHIP_REBUTTED: 'Guardian provided more info',
          })[this.studentIdToGuardian[student.id] ? this.studentIdToGuardian[student.id].application_status : ''],
        },
        {
          name: 'Guardian Email',
          getInfo: student => this.studentIdToGuardian[student.id] ? this.studentIdToGuardian[student.id].email : '',
          sortFunc: (a, b) => (this.studentIdToGuardian[a.id] ? this.studentIdToGuardian[a.id].email : '').localeCompare(this.studentIdToGuardian[b.id] ? this.studentIdToGuardian[b.id].email : ''),
          style: {
            'word-break': 'break-all',
          },
          actionIcon: {
            icon: 'filter_none',
            action: () => {
              const guardianEmails = this.filteredStudents.map(student => this.studentIdToGuardian[student.id].email)
              this.$copyToClipboard(guardianEmails.join('\n'))
              this.$toast('Copied guardian emails.')
            },
          },
        },
        {
          name: 'Status',
          getInfo: student => student.inactive ? 'Inactive' : 'Active',
          sortFunc: (a, b) => a.inactive ? 1 : -1,
        },
        {
          name: 'Ethnicity',
          getInfo: student => student.ethnicity,
          sortFunc: (a, b) => a.ethnicity.localeCompare(b.ethnicity),
        },
        {
          name: 'Gender',
          getInfo: student => student.gender,
          sortFunc: (a, b) => a.gender.localeCompare(b.gender),
        },
        {
          name: 'Course Name',
          getInfo: student => this.$student(student, this.classes).currentCourse.name,
          sortFunc: (a, b) => this.$student(a, this.classes).currentCourse.name.localeCompare(this.$student(b, this.classes).currentCourse.name),
        },
        {
          name: 'Course Month',
          getInfo: student => this.$student(student, this.classes).currentClass.month,
          sortFunc: (a, b) => this.$student(a, this.classes).currentClass.month.localeCompare(this.$student(b, this.classes).currentClass.month),
        },
        {
          name: 'Previous Experience',
          getInfo: student => student.previous_coding_experience || '',
          sortFunc: (a, b) => a.previous_coding_experience.localeCompare(b.previous_coding_experience),
        },
        {
          name: 'Want to learn next',
          getInfo: student => student.want_to_learn_next || '',
          sortFunc: (a, b) => a.want_to_learn_next.localeCompare(b.want_to_learn_next),
        },
        {
          name: 'Notes',
          getInfo: student => student.notes || '',
          editable: true,
          onClick: (student) => {
            this.$modals.show({
              name: 'student-note',
              student: student,
              onSuccess: this.getEntities,
              hardClose: true,
            })
          },
          sortFunc: (a, b) => a.notes.localeCompare(b.notes),
        },
        {
          name: 'Edit Info',
          getInfo: () => 'Edit',
          classFunc: () => 'action-link',
          onClick: (student) => {
            this.$modals.show({
              name: 'create-student',
              onSuccess: this.getEntities,
              info: student,
              hardClose: true,
            })
          }
        },
      ],
      filters: {
        classes: {
          chosen: [],
          data: this.classes,
          options: {
            instruction: 'Filter by class',
            all: 'All Classes',
            classFunc: key => 'class',
            getEntityName: aClass => `${courses[aClass.course_id].name} - ${aClass.month}`,
            filterFunc: student => {
              const chosen = this.filters.classes.chosen
              return !chosen.length || student.classes.find(classId => chosen.includes(classId))
            },
          }
        },
        user_type: {
          chosen: [],
          data: {
            ADULT_STUDENT: {
              name: 'Adult'
            },
            ONLINE_STUDENT: {
              name: 'Youth'
            }
          },
          options: {
            instruction: 'Filter by student type',
            all: 'All Student Types',
            classFunc: () => 'user_type',
            getEntityName: user_type => user_type['name'],
            filterFunc: student => {
              const chosen = this.filters.user_type.chosen
              // console.log("chosen :", chosen, "user_type: ", student.user_type)
              return !chosen.length || student.user_type.find(t => chosen.includes(t))
            }
          }
        }
      },
      currentTab: 'Enrolled',
      tabs: [
        {
          title: 'Enrolled',
        },
        {
          title: 'Unenrolled',
        },
      ],
    }
  },
  computed: {
    filteredStudents () {
      let filteredStudents = Object.values(this.filters)
        .map(filter => filter.options.filterFunc)
        .reduce((remaining, filter) => remaining.filter(filter), this.students)
        .filter(student => {
          if (this.currentTab === 'Enrolled')
            return this.$student(student, this.classes).currentCourse.id
          else if (this.currentTab === 'Unenrolled')
            return !this.$student(student, this.classes).currentCourse.id
          else
            return true
        })

      const sortFunc = this.cells.find(cell => cell.name === this.sorting.by).sortFunc
      const sorted = filteredStudents.sort(sortFunc)
      return this.sorting.ascending ? sorted : sorted.reverse()
    },
  },
  methods: {
    async getEntities () {
      this.students = []
      const usersRef = this.$firestore.collection('users')
      //const studentUserTypes = ['STUDENT', 'ONLINE_STUDENT']
      const studentAndLocationPromises = (await usersRef.where('user_type', 'array-contains-any', ['ONLINE_STUDENT','ADULT_STUDENT']).get()).docs.map(doc => doc.data())
        .map(async student => {
          if (!student.user_type.includes('ADULT_STUDENT')) {
            const guardian = (await usersRef.doc(student.guardian_id).get()).data()
            this.studentIdToGuardian[student.id] = guardian
          }
          //const startDate = (await this.$firestore.collection('classes').doc(student.start_date_class_id).get()).data()
          //this.studentIdToStartDateClass[student.id] = startDate
          this.students.push(student)
        })
      await Promise.all(studentAndLocationPromises)
      this.isReady = true
    },
    getFilters () {
      return new Promise(async resolve => {
        await Promise.all(Object.keys(this.filters).map(filterKey => {
          const options = this.filters[filterKey].options
          let ref = this.$firestore.collection(options.databaseName || filterKey)
          if (options.where) ref = ref.where(...options.where)
          
          return new Promise(async resolve => {
            const allEntities = (await ref.get()).docs.reduce((acc, doc) => {
              acc[doc.id] = doc.data()
              return acc
            }, {})
            this.filters[filterKey].data = options.filterEntitiesUponArrival ? options.filterEntitiesUponArrival(allEntities) : allEntities
            resolve()
          })
        }))
        resolve()
      })
    },
    onStudentClick (student) {
      this.$router.push({name: 'AdminStudentView', params: {studentId: student.id}})
    },
  },
  async mounted () {
    //await this.getFilters()
    this.getEntities()
    this.classes = await this.$classes().classList()
    this.filters.classes.data = this.classes
  },
}
</script>

<template lang="pug">
  #admin-students-main.admin-main
    .admin-students-container.admin-container
      .admin-title Students
        .button.pro-button.minor(@click='$modals.show({name: "create-student", onSuccess: getEntities,})') Create Student
      .admin-content
        .filters-holder
          .filter(
            v-for='(filter, key, idx) in filters'
          )
            .title {{filter.options.instruction}}
            .options-holder
              .option.all(
                @click='filter.chosen = []'
                :class='!filter.chosen.length ? "chosen" : ""'
              ) {{filter.options.all}}
              .option(
                v-for='(entity, key, idx) in filter.data'
                @click='filter.chosen[filter.chosen.includes(key) ? "remove" : "push"](key)'
                :class='filter.options.classFunc(key) + " " + key + (!filter.chosen.length || filter.chosen.includes(key) ? " chosen" : "")'
              ) 
                .name {{filter.options.getEntityName(entity)}}
        .tab-holder
          .tab(
            v-for='tab in tabs'
            :class='currentTab === tab.title ? "active" : "inactive"'
            @click='currentTab = tab.title'
          ) {{tab.title}}
        entities-table(
          :entities='filteredStudents'
          :cells='cells'
          :initialSorting='sorting'
          customColumnWidths='136px 64px 108px 150px 220px 90px 140px 150px 180px 150px 230px 230px 230px 150px'
          @onSortingChange='newSorting => sorting = newSorting'
          :tableStyle='{"max-width": "calc(100vw - 400px)", "max-height": "400px"}'
        )
              
</template>

<style lang="sass" scoped>
  @import '$styles/admin.sass'
  #admin-students-main
    .admin-students-container
      .admin-content
        .filters-holder
          margin-bottom: 16px
          .filter
            display: grid
            grid-template-columns: 180px auto
            align-items: center
            margin-bottom: 24px
            .title
              @extend .font-2
          .options-holder
            display: flex
            max-width: calc(100vw - 500px)
            overflow-x: scroll
            padding-bottom: 8px
            .option
              padding: 8px 16px
              margin: 0 8px
              color: white
              cursor: pointer
              border-radius: 8px
              font-size: 14px
              box-shadow: 0 2px 2px 0 $mediumgrey
              box-shadow: none
              transition: .25s all
              opacity: .5
              display: grid
              align-items: center
              min-width: 140px
              max-width: 200px
              //white-space: nowrap
              &.class-group
                background-color: black
              &.class, &.user_type
                background-color: $lightgrey
                color: black
              &.all
                background-color: white
                color: black
                border: thin black solid
              &.chosen
                opacity: 1
                box-shadow: 0 2px 2px 0 $mediumgrey
              &:hover
                box-shadow: 0px 2px 2px 0 $mediumgrey
</style>